<template>
    <CDropdown inNav
               class="c-header-nav-items"
               placement="bottom-end"
               add-menu-classes="pt-0">
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img v-if="$store.state.avatarUrl" :src="$store.state.avatarUrl"
                         class="c-avatar-img" />
                    <img v-else src="/avatarpl.jpg"
                    class="c-avatar-img " />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div"
                         class="text-center"
                         color="light">
            <strong>Settings</strong>
        </CDropdownHeader>
        <CDropdownItem v-if="$store.state.isLoggedIn" @click="profile()">
            <CIcon name="cil-user" /> Profile
        </CDropdownItem>
        <!--<CDropdownItem>
        <CIcon name="cil-file" /> Projects
        <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>
    </CDropdownItem>-->
        <CDropdownDivider />
        <CDropdownItem v-if="!$store.state.isLoggedIn" @click="login()">
            <CIcon name="cil-lock-locked" /> Login
        </CDropdownItem>
        <CDropdownItem v-else @click="logout()">
            <CIcon name="cil-lock-locked" /> Logout
        </CDropdownItem>
    </CDropdown>
</template>

<script>
    import apis from '../common/network'

    export default {
        name: 'TheHeaderDropdownAccnt',
        data() {
            return {
                itemsCount: 42
            }
        },
        methods: {
            logout: function () {
               
                apis.logout()
            },
            login: function () {
                apis.navigateToLogin(window.location.pathname)
            },
            profile: function () {
                this.$router.replace({ name: 'Profile' })
            }
        }
    }
</script>

<style scoped>
    .c-icon {
        margin-right: 0.3rem;
    }
</style>